export const DOWNLOAD_PROCESS_STATEMENT_PDF_SUCCESS = 'DOWNLOAD_PROCESS_STATEMENT_PDF_SUCCESS';

export const downloadProcessStatementPdfFileSuccess = () => ({
    type: DOWNLOAD_PROCESS_STATEMENT_PDF_SUCCESS,
});
